/**
 * The models an agent can be set to think with, and how to say one out loud.
 *
 * ## Why this is in the kit and not in the screen that edits it
 *
 * Two screens render a model: the panel that *sets* it and the panel that
 * *reports* it. If the editor knows `claude-opus-5` is "Opus 5" and the
 * report does not, a person picks a friendly name from a list and then sees
 * an id in the record of what they picked — which reads as though the change
 * did not take.
 *
 * ## Why it is a literal list and not read from the kernel
 *
 * The kernel has no opinion about models. It governs what an agent may
 * *touch*; what it thinks with is Anthropic's list, and there is nothing here
 * to drift from. A model in force that is not on this list is still named
 * rather than being silently replaced — `modelLabel` falls back to the id.
 */
export const MODELS = [
  ["claude-opus-5", "Opus 5", "most capable, most expensive"],
  ["claude-sonnet-5", "Sonnet 5", "balanced"],
  ["claude-haiku-4-5-20251001", "Haiku 4.5", "fastest, cheapest"],
];

/** `"claude-opus-5"` → `"Opus 5"`; anything unknown → itself. */
export function modelLabel(id) {
  const found = MODELS.find(([key]) => key === id);
  return found ? found[1] : id;
}

/** `"claude-opus-5"` → `"Opus 5 — most capable, most expensive"`. */
export function modelChoice(id) {
  const found = MODELS.find(([key]) => key === id);
  return found ? `${found[1]} — ${found[2]}` : id;
}
